export const fileDeliveryApiUrl = (path: string): string => `api/file-delivery-api/v2/${path}`;
